import { Component } from "@angular/core";
import { Guide } from "../../models/guide";
import { GuidesService } from "../../services/guides.service";
import { ActivatedRoute } from "@angular/router";
import AppConstants from "../../constants/AppConstants";

@Component({
  selector: "app-guides",
  templateUrl: "./guides.component.html",
  styleUrls: ["./guides.component.scss"],
})
export class GuidesComponent {
  guides: Guide[] = [];
  searchQuery = "";
  count: number;
  readonly DEFAULT_PAGE_SIZE = AppConstants.DEFAULT_PAGE_SIZE;
  readonly DEFAULT_PAGE_SIZE_OPTIONS = AppConstants.DEFAULT_PAGE_SIZE_OPTIONS;
  readonly DEFAULT_PAGINATION_INFO = { pageIndex: 0, pageSize: 10 };
  pageIndex = 0;
  pageCursors: any[] = [];
  currentPageSize = 10;
  constructor(
    private guideService: GuidesService,
    private route: ActivatedRoute,
  ) {
    route.params.subscribe((val) => {
      this.fetchList(this.DEFAULT_PAGINATION_INFO);
    });
  }

  getFileCount(guide) {
    let fileCount = 0;
    if (guide.photos) {
      fileCount += guide.photos.length;
    }
    if (guide.video) {
      fileCount += guide.video.length;
    }
    return fileCount;
  }

  pageChanged({ pageIndex, pageSize }) {
    this.fetchList(
      {
        pageIndex,
        pageSize,
      },
      this.searchQuery,
    );
  }

  search(input) {
    this.pageIndex = 0;
    this.pageCursors = [];
    this.fetchList({ pageIndex: 0, pageSize: this.currentPageSize }, input);
  }

  private fetchList(pageInfo, searchParam?: string) {
    this.pageIndex = pageInfo.pageIndex;
    const cursorForPage = this.pageIndex > 0 ? this.pageCursors[this.pageIndex - 1] : undefined;
    const obj = {
      paginationData: {
        pageIndex: pageInfo.pageIndex,
        pageSize: pageInfo.pageSize,
        after: cursorForPage,
      },
      searchParam: searchParam,
    };
    this.guideService.getAllGuides(obj).subscribe((result) => {
      console.log(result);
      if (result && result.data) {
        const data = result.data["guides"];

        this.guides = data.edges.map((edge) => edge.node);
        this.count = data.totalCount;
        this.pageCursors[this.pageIndex] = data.pageInfo;
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/guides/guides.component.ts